import { styled } from "@mui/material/styles";
import Tooltip, { tooltipClasses } from "@mui/material/Tooltip";
import {
  formatNegativeNumber,
  formatTextValue,
  getMultiTagString,
  getPersonAvatars,
  getTextWithColor,
  getValueDiv,
} from "../../../utils/utilityFunctions/stringUtility";

/* ----------------------------- VALUE RENDERER ---------------------------- */
export const renderValue = (header, parsedValue, fieldValue) => {
  if (["dropdown", "Listbox"].includes(header?.type)) {
    return getTextWithColor(parsedValue);
  }

  if (["person", "multi_person"].includes(header?.type)) {
    return getPersonAvatars(parsedValue);
  }

  if (header?.type === "number") {
    return formatNegativeNumber(
      parsedValue,
      header?.meta?.numberFormat?.negativeFormat,
      header?.meta?.numberFormat?.selectedOption,
      header?.meta?.numberFormat?.decimalPlaces,
      header?.meta?.numberFormat?.separators,
      header?.meta?.numberFormat?.symbol
    );
  }

  if (header?.type === "date") {
    return parsedValue || "--";
  }

  if (header?.type === "text") {
    return formatTextValue(parsedValue, header?.meta?.textFormat?.textSelectedOption, false, header.meta);
  }

  if (parsedValue?.value) {
    return (
      <HtmlTooltip
        arrow
        disableHoverListener={!parsedValue?.value}
        title={<div className="max-w-[320px] overflow-auto">{parsedValue?.value || ""}</div>}
      >
        <div className="inline-block max-w-full overflow-hidden accounting-ellipsis ps-1 text-black text-[12px]">
          {getValueDiv(parsedValue?.value || "--")}
        </div>
      </HtmlTooltip>
    );
  }

  if (header?.type === "multiselect") {
    return (
      <div className="inline-block max-w-full overflow-hidden accounting-ellipsis text-black text-[12px]">
        {getMultiTagString(parsedValue)}
      </div>
    );
  }
};

/* -------------------------------------------------------------------------- */
/*                               TOOLTIP STYLED                               */
/* -------------------------------------------------------------------------- */
export const HtmlTooltip = styled(({ className, ...props }) => <Tooltip {...props} classes={{ popper: className }} />)(
  ({ theme }) => ({
    [`& .${tooltipClasses.tooltip}`]: {
      backgroundColor: "white",
      color: "rgba(0, 0, 0, 0.87)",
      maxWidth: 320,
      maxHeight: 100,
      fontSize: theme.typography.pxToRem(12),
      border: "1px solid #dadde9",
    },
  })
);
